<template>
    <div
        class="editorImageElement"
        :id="el.id"
        :style="el.isSvg ? '' : styling"
        style="width: 100%; height:100%"
    >
        <img
            :src="el.src"
            style="width: 100%; height:100%; max-width: 100%;"
            v-if="!el.isSvg"
        />
        <inline-svg
            :src="el.src"
            v-if="el.isSvg"
        />
    </div>
</template>

<script>
    export default {
        props: ['el'],
        computed: {
            styling() {
                return {
                    filter: `blur(${this.el.filters.blur.value}px) brightness(${this.el.filters.brightness.value}%) contrast(${this.el.filters.contrast.value}%) grayscale(${this.el.filters.grayscale.value}%) sepia(${this.el.filters.sepia.value}%)`
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    img {
        max-width: 100%;
        width: 100%;
        height: 100%;
    }
</style>